import pathToRegexp from 'path-to-regexp';

// TODO: add cache limit?
const compilePathCache = {};
function compilePath(path) {
  if (compilePathCache[path]) {
    return compilePathCache[path];
  }

  const keys = [];
  const pattern = pathToRegexp(path, keys);

  const parsedPath = {
    pattern,
    keys,
  };

  compilePathCache[path] = parsedPath;

  return parsedPath;
}

export default compilePath;
